import { HeaderTopNav } from 'structure/Layouts/SFILayouts/BaseLayout/components/HeaderTopNav';
import { AccordionComponent } from '@dapp/multi-lib/legacy/accordion';
import { ChevronDown } from 'baseui/icon';
import {
  MOBILEMENU,
  TESTNET_LINKS,
  TESTNET_NAV_LINKS,
} from 'structure/Layouts/SFILayouts/BaseLayout/components/HeaderCommon/menu';
import { Button } from 'structure/home/components/Button';
import Link from 'next/link';
import { Body2, Normal2, Tiny1 } from 'components/Typography';
import { ConnectInfoButton } from 'components/Header/ConnectInfoButton';
import { ModalMenu } from 'structure/Layouts/SFILayouts/BaseLayout/components/ModalMenu';
import React, { useState } from 'react';
import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import { headerStatus } from 'interfaces/header-status.enum';
import { useTranslation } from 'react-i18next';
import { getStaticAssetUrl } from 'utils/url';

interface HeaderCommonMobileModal {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const HeaderCommonMobileModal = (props: HeaderCommonMobileModal) => {
  const { open, onOpenChange } = props;
  const router = useRouter();
  const pathname = usePathname();
  const { t } = useTranslation('common');
  const [collapse, setCollapse] = useState(false);
  const onChange = () => {
    setCollapse(!collapse);
  };

  const panelList = [
    {
      title: (
        <>
          <span className='flex items-center gap-1'>
            Testnet
            <Tiny1 className='text-negative-800'>
              {t('LINK_STATUS.' + headerStatus.ENDED)}
            </Tiny1>{' '}
          </span>
        </>
      ),
      key: 'Testnet',
      content: (
        <>
          <div className='max-h-[400px] overflow-y-auto pb-3'>
            <div className='flex flex-col gap-5'>
              {TESTNET_NAV_LINKS?.map((item, index) => {
                const isActive = pathname === item.href;
                return (
                  <div
                    key={index}
                    className={`group flex flex-col justify-center gap-2 px-4 py-2 ${item.order} ${isActive ? 'bg-white' : ''} ${item.status !== headerStatus.ENDED && 'hover:bg-white'}`}
                  >
                    <Link
                      href={
                        item.status === headerStatus.ENDED ||
                        item.status === headerStatus.COMING_SOON
                          ? ''
                          : item.href
                      }
                      key={index}
                      target={
                        item.status === headerStatus.ENDED ||
                        item.status === headerStatus.COMING_SOON
                          ? ''
                          : item.target
                      }
                      className='flex flex-col'
                    >
                      <Normal2
                        className={`gap-1 font-bold ${item.status === headerStatus.ENDED ? 'pointer-events-none cursor-not-allowed opacity-50' : 'group-hover:text-light-textPrimary'} ${isActive ? 'text-light-textPrimary' : 'text-white-200'} flex items-center`}
                      >
                        {item.title}{' '}
                      </Normal2>
                      <Body2 className='pt-1 text-[0.875rem] font-light text-mono-100'>
                        {item.subTitle}
                      </Body2>
                    </Link>
                  </div>
                );
              })}
            </div>
            <div className='flex flex-col gap-4 pt-9'>
              {TESTNET_LINKS?.map((item, index) => (
                <Link
                  href={item.href}
                  key={index}
                  target={item.target}
                  className={`group px-3 py-1.5 hover:bg-white ${item.disabled && 'pointer-events-none cursor-not-allowed opacity-50'}`}
                >
                  <Normal2 className='flex gap-2 font-bold text-white-200 group-hover:text-light-textPrimary'>
                    {item.link}
                    <Image
                      src={getStaticAssetUrl(
                        '/sfi/static/svgs/right_arrow.svg'
                      )}
                      width={14}
                      height={10}
                      alt=''
                    />
                  </Normal2>
                </Link>
              ))}
            </div>
          </div>
        </>
      ),
    },
  ];
  const combinedMenu = MOBILEMENU?.filter((item) => item.visible);

  return (
    <ModalMenu open={open} onOpenChange={onOpenChange} contentClassname='pb-0'>
      <div className='flex w-full flex-row items-center justify-between p-5 pt-6'>
        <HeaderTopNav open={open} onOpenChange={onOpenChange} />
      </div>
      <div className='px-5 pb-12'>
        <div className='flex flex-col items-start gap-4 overflow-y-auto '>
          <AccordionComponent
            overrides={{
              Header: {
                style: ({ $theme }) => ({
                  paddingTop: '12px',
                  paddingBottom: '12px',
                  paddingLeft: '12px',
                  paddingRight: '12px',
                  display: 'flex',
                  borderTopLeftRadius: '6px',
                  borderTopRightRadius: '6px',
                  borderBottomLeftRadius: collapse ? '0px' : '6px',
                  borderBottomRightRadius: collapse ? '0px' : '6px',
                  justifyContent: 'space-between',
                  fontWeight: 600,
                  fontSize: $theme.sizing.scale600,
                  letterSpacing: '0.2px',
                  outline: 'none',
                  color: '#F5F5F5 !important',
                }),
              },
              PanelContainer: {
                style: ({ $theme }) => ({
                  color: '#F5F5F5',
                  border: '1px solid #fff',
                }),
              },
              Content: {
                style: () => ({
                  paddingTop: '10px',
                  paddingBottom: '0px',
                  paddingRight: '0px',
                  paddingLeft: '0px',
                  backgroundColor: '#000000',
                  borderBottomLeftRadius: '6px',
                  borderBottomRightRadius: '6px',
                }),
              },
              ToggleIcon: {
                component: ({ $expanded }: { $expanded: boolean }) => (
                  <div
                    style={{
                      transform: $expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    }}
                  >
                    <ChevronDown size={20} color='#ffffff' />
                  </div>
                ),
              },
            }}
            panelList={panelList}
            onChange={onChange}
          />
          {combinedMenu
            ?.filter((item) => item.visible)
            ?.map((item, index) => (
              <Button
                key={index}
                className={`flex items-center p-3 text-sm ${item.status === headerStatus.COMING_SOON && 'pointer-events-none'}`}
                style='link'
                onClick={() =>
                  item.isExternal
                    ? window.open(item.href, '_blank')
                    : router.push(item.href)
                }
              >
                {item.title}
                {item.status && (
                  <Tiny1 className='ps-1 text-positive-800'>
                    {t('LINK_STATUS.' + item.status)}
                  </Tiny1>
                )}
              </Button>
            ))}
        </div>
      </div>
      <div
        className={
          'sticky bottom-0 flex w-full items-center justify-center gap-2 bg-light-textPrimary py-3'
        }
      >
        <ConnectInfoButton />
      </div>
    </ModalMenu>
  );
};
